import getWithXHR from 'Common/utils/getWithXHR'
import { getVideoGenresUrl } from '../../endpoints'

const getVideoGenres = () => getWithXHR(getVideoGenresUrl)

export default getVideoGenres
